import React from 'react';
import {Button, Card, CardBody, CardGroup, Col, Container, Row} from "reactstrap";
import {Input} from "semantic-ui-react";
import Login_ICON from "../../../assets/img/login.png";
import * as common from "../../../const/Common/CommonFunc";
import axios from "../../../axios/axios_authorization";
import apiConfig from "../../../axios/axios_api_services";
import Cookies from "js-cookie";
import * as actionCreator from "../../../store/Action";
import {connect} from "react-redux";
import IntlTelInput from "react-intl-tel-input";
import './Style.css';
import * as config from "../../../const/config/config";
import * as qs from "qs";

class App extends React.Component {

  state = {
    hostMobile: "",
    hostMobile_: "",
    hostEntity: "",
    hostPIN: "",
    switch: false
  };

  onHandleChange = name => e => {
    let value = e.target.value;
    switch (name) {
      case 'hostPIN':
        this.setState({hostPIN: value});
        break;
      default:
        break;
    }
  };

  onHandleChangeHostMobile = (condition, value, object, withdialcod) => {
    value = value.startsWith("00") ? "+" + value.substr(2) : value;
    this.setState({hostMobile: withdialcod.substr(1).replace(/\s/g, ""), hostMobile_: value});
  };

  onSubmitToGetUser = () => {
    this.state.hostMobile.trim() === '' ? common.notifyMessage("Please enter login credentials") :
      this.onSubmitToGetUser_();
  };

  onSwitchMobile = () => {
    this.setState({hostEntity: "", hostPIN: "", switch: false});
  };

  onSubmitToGetUser_ = () => {
    this.props.spinnerHandler(true);
    const headers = {
      "device-Id": "123",
      "smart-session-key": "123",
      "userId": 123
    };
    axios.post(apiConfig.HOST_CHECK({mobile: this.state.hostMobile}), null, {headers: headers})
      .then(response => {
        if (response.data && response.data.mobileUser) {
          this.setState({hostEntity: response.data.mobileUser});
          this.onSubmitToSendOTP(response.data.mobileUser);
        } else {
          this.showErrorMessage();
        }

      })
      .catch(error => {
        this.props.spinnerHandler(false);
        this.showErrorMessage();
      });
  };
  showErrorMessage = () => {
    common.notifyMessage("Couldn't find an user with this mobile number in the system ", 0, 3);
  };

  checkHost = (userObj) => {
    this.props.spinnerHandler(false);
    if (userObj !== undefined || userObj !== null) {
      this.props.userHandler(userObj);
      this.props.history.push("/host/dashboard");
    }
  };

  onSubmitToSendOTP = (obj) => {
    let headers = {
      "device-Id": "123",
      "mobileNo": this.state.hostMobile,
      "userId": obj.userId
    };

    axios.post(apiConfig.HOST_OTP_SEND({mobile: this.state.hostMobile}), {}, {headers: headers})
      .then(response => {
        this.setState({switch: true});
      })
      .catch(error => {
        common.notifyMessage("Couldn't send PIN to this mobile number ", 0, 3);
      })
      .finally(fin => {
        this.props.spinnerHandler(false);
      })
  };

  onSubmitToVerifyOTP = () => {
    this.state.hostPIN.trim() === '' ? common.notifyMessage("Please enter PIN") :
      this.onSubmitToVerifyOTP_();
  };

  onSubmitToVerifyOTP_ = () => {
    let headers = {
      "device-Id": "123"

    };
    let authentication = {
      userId: this.state.hostEntity.userId,
      password: this.state.hostPIN
    };

    axios.post(apiConfig.HOST_OTP_VERIFY({mobile: this.state.hostMobile}), authentication, {headers: headers})
      .then(response => {
        this.props.spinnerHandler(false);
        this.onSubmitToVerifyOTP__();
      })
      .catch(error => {
        this.props.spinnerHandler(false);
        if (error.status === 403) {
          common.notifyMessage(error.statusDesc, 0, 3);
        } else {
          common.notifyMessage("This PIN does not valid ", 0, 3);
        }

      });
  };

  onSubmitToVerifyOTP__ = () => {
    this.props.spinnerHandler(true);
    const headers = {
      "Content-Type": "application/x-www-form-urlencoded",
      "Authorization": "Basic " + config.CLIENT_SECRET
    };

    const data = {
      username: this.state.hostMobile.trim(),
      password: this.state.hostPIN.trim(),
      grant_type: 'password'
    };

    axios.post(apiConfig.OAUTH, qs.stringify(data), {headers: headers})
      .then(response => {
        this.props.spinnerHandler(false);
        let data = response.data.user;
        if (data != null) {
          this.setState({
            hostEntity: data
          });
        }

        Cookies.set('68a6102f6ed24899420170004a0273b8', response.data.access_token);
        let obj = data;
        obj.corporateId = data.corporates.length !== 0 ? data.corporates[0].corporateId : 0;
        Cookies.set('3c8bed3b2d6ba6d3076ee8d2f588a4dx', obj);
        Cookies.set('9b8558ba3f051677daf36ebfc67f29fa', response.data.refresh_token);
        this.checkHost(this.state.hostEntity);
      })
      .catch(error => {
        this.props.spinnerHandler(false);
        if (error.status === 403) {
          common.notifyMessage(error.statusDesc, 0, 3);
        } else {
          common.notifyMessage("This PIN does not valid ", 0, 3);
        }
      });
  };
  customPlaceholder = (selectedCountryPlaceholder) => {
    // return selectedCountryPlaceholder.substr(0,2) + "XXXXXXXX";
    return "7XXXXXXXX";
  };
  render() {
    return (
      <div className={"app flex-row align-items-center login-background animated bounceInLeft"}>
        <Container>
          <Row className="justify-content-center">
            <Col md="8">
              <CardGroup style={{boxShadow: '0 30px 60px 0 rgba(0,0,0,0.3)'}}>

                <Card className="p-4" style={{border: 'none'}}>

                  {
                    !this.state.switch ?
                      <CardBody>
                        <h1>Login</h1>
                        <br/>
                        <p className="text-muted">Enter your mobile number and send to get PIN via SMS to sign in to
                          your account.</p>

                        <div className={"display-inline"}>
                          {/*<label className="" style={{fontSize: '28px'}}>*/}
                          {/*<i className="mobile alternate left icon"/>*/}
                          {/*</label>*/}
                          <IntlTelInput
                            style={{width: '100%', marginBottom: '10px'}}
                            type={"text"}
                            fieldName={"Mobile Number"}
                            value={this.state.hostMobile_}
                            containerClassName="intl-tel-input dashboard-intl"
                            inputClassName="form-control"
                            onPhoneNumberChange={this.onHandleChangeHostMobile}
                            required={true}
                            preferredCountries={['lk']}
                            defaultCountry={"lk"}
                            nationalMode={false}
                            icon='mobile alternate'
                            customPlaceholder={this.customPlaceholder}
                          />
                          <label className="lb-text">
                            Mobile
                          </label>
                        </div>

                        <Row>
                          <Col lg='12' md='12' xs="12">
                            <br/>
                            <Button
                              onClick={this.onSubmitToGetUser}
                              className="ui button px-5"
                            >Send PIN via SMS
                            </Button>
                          </Col>
                        </Row>

                      </CardBody>
                      :
                      <CardBody>
                        <h1>Login</h1>
                        <br/>
                        <p className="text-muted">We sent a SMS to {this.state.hostMobile_} with PIN. Enter PIN you
                          received to sign in to your account.</p>

                        <p style={{color: 'blue', cursor: "pointer"}} onClick={this.onSwitchMobile}><i
                          className="arrow alternate left icon"/>Change Mobile</p>

                        <div className={"display-inline"}>
                          {/*<label className="" style={{fontSize: '28px'}}>*/}
                          {/*<i className="star outline left icon"/>*/}
                          {/*</label>*/}
                          <Input
                            focus={true}
                            style={txtStyle}
                            className={"login-username xd"}
                            placeholder='Enter PIN'
                            onChange={this.onHandleChange("hostPIN")}
                          />
                          <label className="lb-text">
                            PIN
                          </label>
                        </div>

                        <Row>
                          <Col lg='12' md='12' xs="12">
                            <br/>
                            <Button
                              onClick={this.onSubmitToVerifyOTP}
                              className="ui button px-5"
                            >Verify and Login
                            </Button>
                          </Col>
                        </Row>

                      </CardBody>
                  }

                </Card>
                <Card className="text-white  py-5 d-md-down-none login-right-side"
                      style={{border: 'none', width: '44%', height: '301px'}}>

                  <img src={Login_ICON} style={{width: '100%', height: '180%', objectFit: 'contain'}} alt={"."}/>

                </Card>
              </CardGroup>
            </Col>
          </Row>
        </Container>
      </div>
    );
  }
}

let txtStyle = {
  marginBottom: '10px',
  height: '45px',
  width: '100%'

}

const mapStateToProps = (state) => ({
  is_spin: state.spinnerReducer.is_spin,

})

const mapDispatchToProps = (dispatch) => {
  return {
    callAllBuildings: (data) => dispatch(actionCreator.callAllBuildings(data)), // Get All Buildings Of Corporate

    spinnerHandler: (data) => dispatch(actionCreator.spinnerHandler(data)),
    userHandler: (data) => dispatch(actionCreator.userHandler(data)),
    // all floors
    receptionAllFloorHandler: (data) => dispatch(actionCreator.receptionAllFloorHandler(data)),
    // all building
    receptionAllBuildingHandler: (data) => dispatch(actionCreator.receptionAllBuildingHandler(data)),
  };

}

export default connect(mapStateToProps, mapDispatchToProps)(App);
